import {
  ANNOUNCEMENTS_CONNECTING,
  ANNOUNCEMENTS_DATA,
} from 'store/types';

const INITIALSTATE = {
  timestamp: null,
  loading: null,
  announcements: []
};

export default function (state = INITIALSTATE, action) {
  switch (action.type) {
    case ANNOUNCEMENTS_CONNECTING:
      return {
        ...Object.assign(state, {
          timestamp: new Date(),
          loading: true,
        })
      };
    case ANNOUNCEMENTS_DATA:
      return {
        ...Object.assign(state, {
          timestamp: new Date(),
          loading: false,
          ...action.payload
        })
      };
    default:
      return state;
  }
};
